import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ToggleService } from '../../components/sidebar/toggle.service';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { CustomizerSettingsComponent } from '../../components/customizer-settings/customizer-settings.component';
import { NavigationCancel, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UsersModule } from "../user/users.module";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { filter } from 'rxjs';
import { CustomizerSettingsService } from '../../helpers/customizer-settings.service';

declare let $: any;

@Component({
  selector: 'app-structure-page',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent, HeaderComponent, FooterComponent, CustomizerSettingsComponent, UsersModule, MatProgressSpinnerModule],
  templateUrl: './structure-page.component.html',
  styleUrl: './structure-page.component.scss'
})
export class StructurePageComponent {

  title = 'Lockers';
  routerSubscription: any;
  location: any;

  // isSidebarToggled
  isSidebarToggled = false;

  // isToggled
  isToggled = false;

  // isLoading
  isLoading = false;

  constructor(
      public router: Router,
      private toggleService: ToggleService,
      public themeService: CustomizerSettingsService
  ) {
      this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
          this.isSidebarToggled = isSidebarToggled;
      });
      this.themeService.isToggled$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
      this.themeService.isLoading$.subscribe(isLoading => {
          this.isLoading = isLoading;
      });
  }

  // ngOnInit
  ngOnInit() {
      this.recallJsFuntions();
  }

  // recallJsFuntions
  recallJsFuntions() {
      this.routerSubscription = this.router.events
          .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
          .subscribe(event => {
              this.location = this.router.url;
              if (!(event instanceof NavigationEnd)) {
                  return;
              }
              window.scrollTo(0, 0);
          });
  }

  // Dark Mode
  toggleTheme() {
      this.themeService.toggleTheme();
  }

  // Sidebar Dark
  toggleSidebarTheme() {
      this.themeService.toggleSidebarTheme();
  }

  // Right Sidebar
  toggleRightSidebarTheme() {
      this.themeService.toggleRightSidebarTheme();
  }

  // Hide Sidebar
  toggleHideSidebarTheme() {
      this.themeService.toggleHideSidebarTheme();
  }

  // Header Dark Mode
  toggleHeaderTheme() {
      this.themeService.toggleHeaderTheme();
  }

  // Card Border
  toggleCardBorderTheme() {
      this.themeService.toggleCardBorderTheme();
  }

  // Card Border Radius
  toggleCardBorderRadiusTheme() {
      this.themeService.toggleCardBorderRadiusTheme();
  }

  // RTL Mode
  toggleRTLEnabledTheme() {
      this.themeService.toggleRTLEnabledTheme();
  }

}
